// extracted by mini-css-extract-plugin
export default {"container":"FloatingActions_container__ygOqi","action":"FloatingActions_action__KD8Lm","tooltip":"FloatingActions_tooltip__mJ+lN"};